import Minze, { MinzeElement, Reactive, EventListeners } from 'minze'
import { MODALS } from '../../constants'
import MainModule from '../../modules/main'
import { Locale } from '../../modules/locale'
import { Font } from '../../constants'

Locale.getInstance().registerKeySet('fr', 'resetPassword', {
  title: 'Réinitialiser votre mot de passe',
  createTitle: 'Créer un mot de passe',
})

Locale.getInstance().registerKeySet('en', 'resetPassword', {
  title: 'Reset your password',
  createTitle: 'Create a password',
})

export interface LvcResetPassword {}

export class LvcResetPassword extends MinzeElement {
  modalId = MODALS.RESET_PASSWORD

  reactive: Reactive = [['isCreateMode', false]]

  onReady(): void | Promise<void> {
    const createPasswordParam = new URLSearchParams(window.location.search).get('createPassword')
    if (createPasswordParam && createPasswordParam === 'true') this.isCreateMode = true
  }

  goBack = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goToLastPage()
  }

  html = () => {
    return `
			<lvc-modal
				modal-id="${this.modalId}"
				narrow="true"
				background="transparent"
				modal-title="${Locale.getKey(this.isCreateMode ? 'resetPassword.createTitle' : 'resetPassword.title')}"
				titleSize="36px"
			>
				<div slot="lvc-modal-top">
					<lvc-box color="#1E007D" display="flex" alignItems="center" id="link-back">
						<lvc-chevron-left-icon></lvc-chevron-left-icon>
						<lvc-box mt="-4px">
							<lvc-text font-preset="small" >${Locale.getKey('general.previous')}</lvc-text>
						</lvc-box>
					</lvc-box>
				</div>
				<div slot="lvc-modal-content">
					<lvc-reset-password-content></lvc-reset-password-content>
				</div>
			</lvc-modal>
		`
  }

  css = () => `
    :host {
      
    }
    #link-back {
      cursor: pointer;
    }

   
  `

  eventListeners: EventListeners = [['#link-back', 'click', this.goBack]]
}
